import { createFileRoute } from '@tanstack/react-router';

import { MonitoringDataHealthPage } from '@/areas/market-insights/MarketInsights/pages/MonitoringDataHealthPage';
import type { PageStaticData } from '@/shared/routing';

// The monitoring layout (`monitoring/route.tsx`) checks who may open this page.
export const Route = createFileRoute('/_authenticated/monitoring/_sidebar/data-health')({
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <MonitoringDataHealthPage />;
}
